<template lang="pug">
	.no-drop-box
		p.spacey {{ message }}
</template>

<script>
export default {
	name : 'no-drop-box',

	computed : {
		driveLinkState() {
			return this.$store.state.driveLinkState;
		},

		message() {
			const { driveLinkState } = this;
			const messages = {
				'not-electron' : 'Switch To Desktop App To Upload Files',
				'invalid'      : 'G Drive File Path is invalid. Click settings in the side bar to edit it'
			};

			return messages[driveLinkState];
		}
	},
};
</script>

<style lang="scss">
	.no-drop-box {
		p {
			text-align: center;
			font-size: 14px;
		}
	}
</style>
